import { Button } from "antd";
import { FaStar } from "react-icons/fa6";
import { useInfoUser } from "../../../store/UserStore";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { IoMdWarning } from "react-icons/io";
import "./GroupCall.scss";

const FeedBack = () => {
  const { user, languageMap } = useInfoUser();

  const [searchParams, setSearchParams] = useSearchParams();
  const [audioError, setAudioError] = useState(false);

  useEffect(() => {
    setAudioError(searchParams?.get("audio_error"));
  }, []);

  return (
    <div className="h-[100vh] text-[white] text-center flex flex-col justify-between py-[150px] bg-[black]">
      <div>
        {audioError && (
          <div className="call-header">
            <div className="flex gap-[5px] items-center">
              <IoMdWarning size={16} color="yellow" />
              <div>Not found any micro!</div>
            </div>
          </div>
        )}
        <div className="text-[21px]">
          {languageMap?.["call.quality"] ??
            "How do you think about call quality ?"}
        </div>
        <div className="flex gap-[10px] justify-center mt-[20px]">
          <Button
            type="default"
            //   shape="circle"
            className="border-black bg-[black] text-[#575757]"
            size="large"
            icon={<FaStar size={25} />}
            //   onClick={openCallWindow}
          />
          <Button
            type="default"
            //   shape="circle"
            className="border-black bg-[black] text-[#575757]"
            size="large"
            icon={<FaStar size={25} />}
            //   onClick={openCallWindow}
          />
          <Button
            type="default"
            //   shape="circle"
            className="border-black bg-[black] text-[#575757]"
            size="large"
            icon={<FaStar size={25} />}
            //   onClick={openCallWindow}
          />
          <Button
            type="default"
            //   shape="circle"
            className="border-black bg-[black] text-[#575757]"
            size="large"
            icon={<FaStar size={25} />}
            //   onClick={openCallWindow}
          />
          <Button
            type="default"
            //   shape="circle"
            className="border-black bg-[black] text-[#575757]"
            size="large"
            icon={<FaStar size={25} />}
            //   onClick={openCallWindow}
          />
        </div>
      </div>
    </div>
  );
};

export { FeedBack };
